export const STATIC = 'STATIC';
export const DYNAMIC = 'DYNAMIC';
export const isRollingDatePointType = type => type === STATIC || type === DYNAMIC;